import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let active = true;
    const poll = async () => {
      if (attempts.current >= 8) { if (active) setStatus("pending"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!active) return;
        if (data.payment_status === "paid") { setStatus("paid"); setTimeout(() => navigate(`/confirmation/${data.booking_ref}`), 900); return; }
        setTimeout(poll, 2000);
      } catch { if (active) setTimeout(poll, 2000); }
    };
    poll();
    return () => { active = false; };
  }, [sessionId, navigate]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="text-center">
        {status === "checking" && <><Loader2 size={48} className="mx-auto animate-spin text-brand" /><p className="mt-4 text-slate-600">Confirming your payment…</p></>}
        {status === "paid" && <><CheckCircle2 size={56} className="mx-auto text-emerald-500" /><p className="mt-4 font-heading text-lg font-semibold text-navy">Payment successful!</p></>}
        {status === "pending" && <><Loader2 size={48} className="mx-auto animate-spin text-amber-500" /><p className="mt-4 text-slate-600">Payment is processing. You'll receive confirmation shortly.</p><Button className="mt-4 bg-brand" onClick={() => navigate("/dashboard")}>Go to Dashboard</Button></>}
        {status === "error" && <><XCircle size={56} className="mx-auto text-red-500" /><p className="mt-4 text-slate-600">We couldn't verify this payment session.</p><Button className="mt-4 bg-brand" onClick={() => navigate("/")}>Back Home</Button></>}
      </div>
    </div>
  );
}
